import React, {useState} from 'react';
import {Table} from 'reactstrap';
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {student_strings} from "../../translations/student_translations";
import {resource_strings} from "../../translations/resource_translations";
import ClassReportRow from "./ClassReportRow";
import {Redirect} from "react-router-dom";
import Button from "reactstrap/es/Button";

let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let studentStrings = new LocalizedStrings(student_strings);

const ClassReport = (props) => {
    const [data, setData] = useState(props.data);
    const [clientId, setClientId] = useState(null);
    const [yclassId, setYclassId] = useState(null);
    const [isShowingConfirmedOnly, setIsShowingConfirmedOnly] = useState(false);

    function localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    localize();

    function renderTableData() {
        if (data !== null) {
            return data.map((yclass, index) => {
                return (
                    <ClassReportRow yclass={yclass} key={yclass.id} openTicket={{}} deleteTicket={{}} isShowingConfirmedOnly={isShowingConfirmedOnly}
                                    strings={resourceStrings} goToStudent={goToStudent} goToClass={goToClass}/>
                )
            })
        }
    }

    function goToStudent(id) {
        setClientId(id)
    }

    function goToClass(id) {
        setYclassId(id)
    }

    if (clientId) {
        return <Redirect from="*" to={{
            pathname: "/admin/student-profile",
            state: {
                clientId: clientId,
                backToClassReport: true
            }
        }}/>
    }

    if (yclassId) {
        return <Redirect from="*" to={{
            pathname: "/admin/class_overview",
            state: {backToClassReport: true, yclassId: yclassId}
        }}/>
    }

    function toggleMustShowConfirmedOnly(mustShow) {
        setIsShowingConfirmedOnly(mustShow);

    }

    return (
        <div style={{width: "100%"}}>
            <div style={{display: "flex", flexFlow: "row", width: "100%", marginBottom: 20}}>
                <Button onClick={e => toggleMustShowConfirmedOnly(false)} color={isShowingConfirmedOnly ? "secondary" : "success"} type="button" style={{borderRadius: 16}}>
                    {resourceStrings.registered}
                </Button>

                <Button onClick={e => toggleMustShowConfirmedOnly(true)} color={isShowingConfirmedOnly ? "success" : "secondary"} type="button" style={{borderRadius: 16}}>
                    {resourceStrings.confirmed_booking}
                </Button>
            </div>
            {renderTableData()}
        </div>
    );
};

export default ClassReport;